import { Outlet, useLocation } from 'react-router-dom';
import './App.scss';
import { useMainContext } from './context/MainContext';

import { SpotlightOverlay } from './components/SpotlightOverlay';
import { FooterMobile } from './components/FooterMobile';

export const App = () => {
  const { currentPage } = useMainContext();
  const location = useLocation();

  return (
    <div className="app-container">
      <div className="content">
        <SpotlightOverlay />
        <div key={location.pathname}>
          <Outlet />
        </div>
        {currentPage !== 'home' && <FooterMobile />}
      </div>
    </div>
  );
};
